import { useTranslation } from 'react-i18next';
import { TextareaField, TextareaFieldProps } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

export const IntroduceField = (props: Omit<TextareaFieldProps, 'name'>) => {
  const { t } = useTranslation();

  return (
    <TextareaField<InfluencerFormKeys>
      help={t('Tooltip.IntroduceHelp')}
      title={t('TextForm.Introduce')}
      name={InfluencerSharedKeys.introduce}
      placeholder={t<string>('TextForm.Contents Placeholder')}
      {...props}
    />
  );
};
